<mat-form-field class="w-100 control-helper_inline" [hideRequiredMarker]="!attributeDefinition.isRequired" (click)="dateTimePicker.open()">
  <mat-label>{{ label }}</mat-label>

  <input matInput [ngxMatDatetimePicker]="dateTimePicker" [formControl]="control" hidden>

  <div class="date-value">
    {{ control.value ? moment(control.value).format('MM/DD/YYYY hh:mm A') : '\u00A0' }}
  </div>

  <mat-datepicker-toggle matSuffix [for]="dateTimePicker"></mat-datepicker-toggle>
  <button mat-icon-button matSuffix type="button" aria-label="Clear date and time" (click)="clear($event)"
    [disabled]="control?.disabled || control?.value == null">
    <mat-icon>close</mat-icon>
  </button>

  <ngx-mat-datetime-picker #dateTimePicker [touchUi]="true" [enableMeridian]="true" [showSpinners]="false"
    (opened)="onOpen()" [startAt]="openAt" [defaultTime]="defaultTime">
  </ngx-mat-datetime-picker>
  <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>